// src/store/draft.js
import { getPlatform } from '@tencentcloud/universal-api';
export default {
  namespaced: true,
  state: {
    // 电子病历
    electron: {},
    // 小结
    summary: {},
    // 当前用户的右侧tab
    patientTab: {},
    // 预览图片栈
    previewList: [],
  },
  getters: {
    getElectron(state) {
      return state.electron
    },
    getSummary(state) {
      return state.summary
    },
    getPatientTab(state) {
      return state.patientTab
    },
    getPreviewList(state) {
      return state.previewList
    }
  },
  mutations: {
    __VUEX_MY_PERSISTEDSTATE_SET__(state, { key, value }) {
      state[key] = value;
    },
    setElectron(state, payload) {
      state.electron = payload
    },
    removeElectron(state, regId) {
      if (state.electron[regId]) {
        delete state.electron[regId];
      }
    },
    setSummary(state, payload) {
      state.summary = payload
    },
    removeSummary(state, regId) {
      if (state.summary[regId]) {
        delete state.summary[regId];
      }
    },
    SET_PATIENT_TAB(state, payload){
      state.patientTab = {
        ...state.patientTab,
        ...payload
      };
    },
    setPreview(state, payload) {
      console.log('setPreview', payload);
      // 更新/新增
      if(getPlatform() === 'h5') {
        return state.previewList = [payload];
      }
      const result = state.previewList.find(it => it.previewKey === payload.previewKey);
      if(result) {
        state.previewList = state.previewList.map(it => {
          if(it.previewKey === payload.previewKey) {
            return payload;
          }
          return it;
        })
      } else {
        state.previewList = [...state.previewList, payload];
      }
    },
    setPreviewList(state, payload) {
      state.previewList = payload
    }
  },
  actions: {
    // 可选：异步操作
    fetchUserInfo({ commit }, payload) {
      // 异步获取后 commit

    }
  }
}